var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07283 1.63357C7.83964 1.15659 7.15983 1.15659 6.92664 1.63358L1.95342 11.8061C1.74623 12.2299 2.05478 12.7242 2.52652 12.7242H12.4729C12.9447 12.7242 13.2532 12.2299 13.046 11.8061L8.07283 1.63357ZM5.78044 1.07322C6.48002 -0.357736 8.51944 -0.357741 9.21902 1.07321L14.1922 11.2457C14.8138 12.5171 13.8881 14 12.4729 14H2.52652C1.11132 14 0.185659 12.5171 0.807228 11.2457L5.78044 1.07322Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86181 4.75018C6.86181 4.39787 7.14742 4.11226 7.49973 4.11226C7.85204 4.11226 8.13765 4.39787 8.13765 4.75018V8.25873C8.13765 8.61105 7.85204 8.89665 7.49973 8.89665C7.14742 8.89665 6.86181 8.61104 6.86181 8.25873V4.75018Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45662 10.8104C8.45662 11.3389 8.02821 11.7673 7.49975 11.7673C6.97128 11.7673 6.54287 11.3389 6.54287 10.8104C6.54287 10.2819 6.97128 9.85353 7.49975 9.85353C8.02821 9.85353 8.45662 10.2819 8.45662 10.8104Z",
    fill: "#FF0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.af502d86258e1d206a7514c6c8d23ff8.svg";
export { ForwardRef as ReactComponent };